/* eslint-disable i18next/no-literal-string */
import React from 'react'

import { ProductData } from 'models/furniture'

import "./AdminProductDetails.scss"

const AdminProductDetails = ({ productData }: { productData: ProductData }) => (
    <div className="AdminProductDetails">
        <ul>
            <li>Geo Id: {productData.id}</li>
            <li>LocalItemNumber: {productData.localItemNumber}</li>
            <li>GlobalProductId: {productData.globalProductId}</li>
            <li>QA Status: {productData.qaStatus}</li>
            <li>Stacks: {productData.stacks.toString()}</li>
            <li>RenderType: {productData.renderType}</li>
            <li>
                <a
                    href={productData.globalProductAdminUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Jiji Global
                </a>
            </li>
            <li>
                <a
                    href={productData.localProductAdminUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Jiji Local
                </a>
            </li>
        </ul>
    </div>
)

export default AdminProductDetails
